import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/comunicacionInterna/importer/comunicacionInternaImporterActions';

export default importerReducers(actions);
